import React, { useState, useEffect, useRef, useCallback } from "react";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

import ModalConcordanciaGerenciar from '../ModalConcordanciaGerenciar/index';
import ModalEditarTopico from '../ModalEditarTopico/index';
import ModalEditarTomadasAcoes from '../ModalEditarTomadasAcoes/index';
import ModalCompartilharPainel from '../ModalCompartilharPainel/index';
import HomePainel from '../HomePainel/index';
import TopicoList from '../TopicoList/index';
import OpcoesDimensoes from '../OpcoesDimensoes/index';

import GAS from "../../../GAS";

import "./styles.css";

const PainelApropriador = ({ painel, metamodeloAvaliativo, usuario }) => {

    const [painelModel, setPainelState] = useState({});
    const [painelCarregando, setPainelCarregando] = useState(true);
    const [metamodeloAvaliativoModel] = useState(metamodeloAvaliativo);
    const [filtroDimensoes, setFiltroDimensoes] = useState(null);
    const [filtroEixos, setFiltroEixos] = useState(null);
    const [dialogConcordar, setDialogConcordar] = useState(true);
    const [dialogEditarTopico, setDialogEditarTopico] = useState(false);
    const [dialogCompartilhar, setDialogCompartilhar] = useState(false);
    const [homePainel, setHomePainel] = useState(false);
    const [dialogEditarTomadasAcoes, setDialogEditarTomadasAcoes] = useState(false);
    const [editTopico, setEditTopico] = useState(undefined);
    const [expandedMenu, setExpandedMenu] = useState(true);
    const [idSessao] = useState(() => Math.random().toString(36).substring(2, 15) + Date.now().toString(36));
    const { innerWidth: width } = window;
    const usuarioModel = usuario

    const toast = useRef(null);

    const callRequestPainelPermicao = useCallback((emailGestor, emailEditor) => {
        return new Promise((resolve, reject) => {
            let gasObj = GAS.getInstance();
            gasObj.request('MCPAPainelApropriador.instance.SERVICE.GETPainelPermicao', emailGestor, emailEditor)
                .then(RESPONSE => {
                    if (RESPONSE.response) {
                        resolve(RESPONSE.response);
                    } else {
                        reject(new Error('Resposta inválida do servidor'));
                    }
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                let emailGestor = painel.proprietario;
                let emailEditor = usuario.email;

                const painelAtualizado = await callRequestPainelPermicao(emailGestor, emailEditor);
                setPainelState(JSON.parse(JSON.stringify(painelAtualizado)));
            } catch (error) {
                showMessage('error', 'ERRO!', `${error.message}`);
            } finally {
                setPainelCarregando(false);
            }
        };

        fetchData();
    }, [painel.proprietario, usuario.email, callRequestPainelPermicao]);

    const showMessage = (type, summary, detail) => {
        toast.current.show({ severity: type, summary: summary, detail: detail, life: 8000, closable: false });
    }

    const setPainel = (novoPainel) => {
        setPainelState(novoPainel);
    };

    if (painelCarregando) {
        return <div></div>;
    }

    return (
        <div>
            <ModalConcordanciaGerenciar
                visible={dialogConcordar}
                setDialogConcordar={setDialogConcordar}
                setHomePainel={setHomePainel}
                setPainelState={setPainelState}
                callRequestPainelPermicao={callRequestPainelPermicao}
                painel={painelModel}
                usuario={usuarioModel}
            />
            <ModalCompartilharPainel
                visible={dialogCompartilhar}
                setDialogCompartilhar={setDialogCompartilhar}
                painel={painelModel}
                setPainel={setPainel}
                usuario={usuarioModel}
            />
            {dialogEditarTopico && (
                <ModalEditarTopico
                    visible={dialogEditarTopico}
                    setDialogEditarTopico={setDialogEditarTopico}
                    setEditTopico={setEditTopico}
                    setPainel={setPainel}
                    metamodeloAvaliativo={metamodeloAvaliativoModel}
                    filtroEixos={filtroEixos}
                    filtroDimensoes={filtroDimensoes}
                    painel={painelModel}
                    usuario={usuarioModel}
                    editTopico={editTopico || {}}
                    showMessage={showMessage}
                    idSessao={idSessao}
                />
            )}
            {dialogEditarTomadasAcoes && editTopico && (
                <ModalEditarTomadasAcoes
                    visible={dialogEditarTomadasAcoes}
                    setDialogEditarTomadasAcoes={setDialogEditarTomadasAcoes}
                    setEditTopico={setEditTopico}
                    setPainel={setPainel}
                    metamodeloAvaliativo={metamodeloAvaliativoModel}
                    painel={painelModel}
                    usuario={usuarioModel}
                    editTopico={editTopico}
                    showMessage={showMessage}
                    idSessao={idSessao}
                />
            )}

            {homePainel && (
                <div style={{ margin: "10px", marginBottom: "20px", display: "flex", height: "calc(100vh - 4.5rem)" }}>
                    {/* Colocando menu expansível aqui */}
                    {expandedMenu && (
                        <div style={{ flex: 1, height: "100%" }}>
                            <HomePainel
                                painel={painelModel}
                                usuario={usuarioModel}
                                setDialogCompartilhar={setDialogCompartilhar}
                                setPainel={setPainel}
                                showMessage={showMessage}
                            />
                            <OpcoesDimensoes
                                painel={painelModel}
                                filtroDimensoes={filtroDimensoes}
                                setFiltroDimensoes={setFiltroDimensoes}
                                setFiltroEixos={setFiltroEixos}
                                metamodeloAvaliativo={metamodeloAvaliativoModel}
                            />
                        </div>
                    )}
                    {/* Adicionando botão para expandir/recolher menu */}
                    <Button
                        icon={expandedMenu ? "pi pi-chevron-left" : "pi pi-chevron-right"}
                        className="p-button p-button-success p-button-rounded p-button-text p-shadow-1 botao-toggle-menu-lateral"
                        onClick={() => setExpandedMenu(!expandedMenu)}
                    />
                    <div style={{ width: "100vw", height: "100%", background: "#ffffff", borderLeft: "7px solid #e9ecef" }}>
                        {!filtroDimensoes &&
                            <div className="p-d-flex p-jc-center p-ai-center" style={{ height: "100%", textAlign: "center" }}>
                                <p className="p-text-bold" style={{ fontSize: "2rem", color: "#4caf50", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" }}>
                                    Selecione uma Dimensão
                                </p>
                            </div>
                        }
                        {filtroDimensoes &&
                            <TopicoList
                                painel={painelModel}
                                filtroDimensoes={filtroDimensoes}
                                setDialogEditarTopico={setDialogEditarTopico}
                                setDialogEditarTomadasAcoes={setDialogEditarTomadasAcoes}
                                setPainel={setPainel}
                                setEditTopico={setEditTopico}
                                usuario={usuarioModel}
                                showMessage={showMessage}
                                idSessao={idSessao}
                            />
                        }
                    </div>
                </div>
            )}
            <Toast ref={toast} />
        </div>
    );
};

export default PainelApropriador;
